import { render, staticRenderFns } from "./wizarMenuProcesos.vue?vue&type=template&id=2c634e1b"
import script from "./wizarMenuProcesos.vue?vue&type=script&lang=js"
export * from "./wizarMenuProcesos.vue?vue&type=script&lang=js"
import style0 from "./wizarMenuProcesos.vue?vue&type=style&index=0&id=2c634e1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports